export const serializeProducts = (productsRaw, paymentPeriod) => {
  let products = productsRaw.reduce((prev, current) => {
    const {interval, ...rest} = current;
    prev[interval] = rest.products || [];
    return prev;
  }, {});
  Object.keys(products).forEach(key => {
    products[key] = products[key].reduce((prev, item) => {
      prev[item.product_group] = item;
      return prev
    }, {});
  });
  return {products, complianceDashboardPlan: products[paymentPeriod].compliance_dashboard.prices[1]};
};
